import { c } from "react-compiler-runtime";
import { useRef, useState, useEffect } from "react";
import { segmentsEqual } from "../lib/ast-path.js";
function useCursorReveal(fullPath, cursorPath, setExpanded) {
  const $ = c(18);
  let t0;
  if ($[0] !== cursorPath || $[1] !== fullPath) {
    t0 = cursorPath !== void 0 && cursorPath.length >= fullPath.length && fullPath.every((seg, i) => segmentsEqual(cursorPath[i], seg));
    $[0] = cursorPath;
    $[1] = fullPath;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onCursorPath = t0;
  const isAncestor = onCursorPath && cursorPath.length > fullPath.length;
  const isTarget = onCursorPath && cursorPath.length === fullPath.length;
  const nodeRef = useRef(null);
  const [flash, setFlash] = useState(false);
  let t1;
  if ($[3] !== isAncestor || $[4] !== setExpanded) {
    t1 = () => {
      if (isAncestor) {
        setExpanded(true);
      }
    };
    $[3] = isAncestor;
    $[4] = setExpanded;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== cursorPath || $[7] !== isAncestor || $[8] !== setExpanded) {
    t2 = [cursorPath, isAncestor, setExpanded];
    $[6] = cursorPath;
    $[7] = isAncestor;
    $[8] = setExpanded;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  useEffect(t1, t2);
  let t3;
  if ($[10] !== isTarget) {
    t3 = () => {
      var _a;
      if (!isTarget) {
        return;
      }
      setFlash(true);
      const row = ((_a = nodeRef.current) == null ? void 0 : _a.firstElementChild) ?? nodeRef.current;
      row == null ? void 0 : row.scrollIntoView({
        block: "center"
      });
      const timer = setTimeout(() => setFlash(false), 700);
      return () => clearTimeout(timer);
    };
    $[10] = isTarget;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== cursorPath || $[13] !== isTarget) {
    t4 = [cursorPath, isTarget];
    $[12] = cursorPath;
    $[13] = isTarget;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  useEffect(t3, t4);
  let t5;
  if ($[15] !== flash || $[16] !== isTarget) {
    t5 = {
      flash,
      current: isTarget,
      nodeRef
    };
    $[15] = flash;
    $[16] = isTarget;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
export {
  useCursorReveal
};
//# sourceMappingURL=use-cursor-reveal.js.map
